/* unplugin-vue-components disabled */import script from "./ProductBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBase.vue?vue&type=script&setup=true&lang=js"

import "./ProductBase.vue?vue&type=style&index=0&id=653fc016&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653fc016"]])

export default __exports__